import React from 'react';
import { useNavigate } from 'react-router-dom';
import './WithdrawalConfirmWithdrawal.css';

// Mock transaction data
const mockTransaction = {
  amount: 100,
  currency: 'ETH',
  usdValue: 100.00,
  recipientEmail: 'Mark98@gamil.com',
  networkFee: 0.0001,
  receiveAmount: 99.9999
};

const WithdrawalConfirmWithdrawal: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  const handleConfirm = () => {
    navigate('/withdrawal-verify-2fa');
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="confirm-withdrawal-container">
      {/* Header */}
      <header className="confirm-withdrawal-header">
        <button className="confirm-withdrawal-back-btn" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="confirm-withdrawal-title">Confirm Withdrawal</h1>
      </header>

      {/* Content */}
      <div className="confirm-withdrawal-content">
        {/* You will send card */}
        <div className="confirm-withdrawal-send-card">
          <span className="confirm-withdrawal-send-label">You will send</span>
          <div className="confirm-withdrawal-send-amount">
            <span className="confirm-withdrawal-send-value">{mockTransaction.amount}</span>
            <span className="confirm-withdrawal-send-currency">{mockTransaction.currency}</span>
          </div>
          <span className="confirm-withdrawal-send-usd">≈ ${mockTransaction.usdValue.toFixed(2)} USD</span>
        </div>

        {/* Transaction Details card */}
        <div className="confirm-withdrawal-details-card">
          <h2 className="confirm-withdrawal-details-title">Transaction Details</h2>

          <div className="confirm-withdrawal-detail-section">
            <span className="confirm-withdrawal-detail-label">Recipient Email</span>
            <span className="confirm-withdrawal-detail-email">{mockTransaction.recipientEmail}</span>
          </div>

          <div className="confirm-withdrawal-divider"></div>

          <div className="confirm-withdrawal-detail-row">
            <span className="confirm-withdrawal-detail-label">Amount</span>
            <span className="confirm-withdrawal-detail-value">{mockTransaction.amount} {mockTransaction.currency}</span>
          </div>

          <div className="confirm-withdrawal-detail-row">
            <span className="confirm-withdrawal-detail-label">Network Fee</span>
            <span className="confirm-withdrawal-detail-value">{mockTransaction.networkFee} {mockTransaction.currency}</span>
          </div>

          <div className="confirm-withdrawal-divider"></div>

          <div className="confirm-withdrawal-detail-row confirm-withdrawal-receive-row">
            <span className="confirm-withdrawal-receive-label">You will receive</span>
            <span className="confirm-withdrawal-receive-value">{mockTransaction.receiveAmount} {mockTransaction.currency}</span>
          </div>
        </div>

        {/* Important Notice */}
        <div className="confirm-withdrawal-notice">
          <h3 className="confirm-withdrawal-notice-title">⚠️ Important Notice</h3>
          <p className="confirm-withdrawal-notice-text">
            Please verify all details carefully. Cryptocurrency transactions cannot be reversed.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="confirm-withdrawal-actions">
          <button className="confirm-withdrawal-confirm-btn" onClick={handleConfirm}>
            Confirm Withdrawal
          </button>
          <button className="confirm-withdrawal-cancel-btn" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default WithdrawalConfirmWithdrawal;
